import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useEffect } from "react";
import { useAppLogoAsset } from "@shared/hooks/useAppLogoAsset";

const Container = styled.div`
  /* padding: 2rem; */
  display: grid;
  /* flex-direction: column; */
  /* align-items: center; */
  /* justify-content: center; */
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 2fr;
  gap: 1rem;
  color: ${(p) => p.theme.text.colors.primary};
  text-align: center;

  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: ${(p) => p.theme.colors.background};
  overflow: hidden;

  transition: 400ms;
  transform: translateY(100vh);
  opacity: 0;

  &.active {
    transform: translateY(0);
    opacity: 1;
  }
`;

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 3rem;

  h4,
  h5,
  h6 {
    max-width: 720px;
  }

  h4,
  h5 {
    transition: 300ms;
    transition-delay: 1000ms;
    opacity: 0;
  }

  &.active {
    h4,
    h5 {
      opacity: 1;
    }
  }

  ${(p) => p.theme.media.mobileDown} {
    padding: 3rem 2rem;
  }
`;

const SuccessMessage = styled(Typography)`
  font-weight: 600;
`;

const LogoContainer = styled.div<{ $imgHeight: string }>`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-color: ${(p) => p.theme.colors.primary};
  width: 100%;
  padding: 4rem 2rem;

  img {
    height: ${(p) => p.$imgHeight};
  }
`;

const Icon = styled(Typography)`
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px ${(p) => p.theme.colors.primary};
  border-radius: 50%;
  padding: 0.5rem;
  font-weight: 600;
  color: ${(p) => p.theme.colors.primary};

  transition: 300ms;
  transition-delay: 700ms;
  transform: scale(0.8);
  opacity: 0;

  &.active {
    transform: scale(1);
    opacity: 1;
  }

  svg {
    width: 4rem;
    height: 4rem;

    ${(p) => p.theme.media.mobileDown} {
      width: 3rem;
      height: 3rem;
    }
  }
`;

type Props = {
  message: string;
  description?: string;
  redirectUrl?: string;
  active: boolean;
};

export const SuccessSubscriptionMessage = (props: Props) => {
  const { message, description, redirectUrl, active } = props;
  const {
    src: logoSrc,
    alt: logoAlt,
    height: logoHeight,
  } = useAppLogoAsset("white", "xl");

  useEffect(() => {
    if (active && redirectUrl) {
      const timer = setTimeout(() => {
        window.location.replace(redirectUrl);
      }, 20000);

      return () => clearTimeout(timer);
    }
  }, [active, redirectUrl]);

  return (
    <Container className={active ? "active" : undefined}>
      <LogoContainer
        className={active ? "active" : undefined}
        $imgHeight={logoHeight}
      >
        <img src={logoSrc} alt={logoAlt} />
      </LogoContainer>
      <SuccessContainer className={active ? "active" : undefined}>
        <Icon className={active ? "active" : undefined}>
          <CheckIcon fontSize="large" />
        </Icon>
        <SuccessMessage mt={2} variant="h4">
          {message}
        </SuccessMessage>
        {!!description && (
          <Typography variant="h5" mt={1} fontWeight={300}>
            {description}
          </Typography>
        )}
      </SuccessContainer>
    </Container>
  );
};
